import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  OnChanges,
} from "@angular/core";
import {
  IshikawaItem,
  AnalisisMethod,
} from "src/app/shared/interfaces/treatment";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { MIshikawaItem } from "src/app/shared/models/ishikawa-item.model";
import { MCause } from "src/app/shared/models/cause.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MCauseArray } from "src/app/shared/models/cause-array.model";

@Component({
  selector: "app-method-ishikawa",
  templateUrl: "./method-ishikawa.component.html",
  styleUrls: ["./method-ishikawa.component.scss"],
})
export class MethodIshikawaComponent implements OnInit, OnChanges {
  constructor(
    private toast: ToastrService,
    private translate: TranslateService,
    private modalService: NgbModal
  ) {}

  @Input() public data: MCause[];
  @Input() public noConformity: any;
  @Input() public method: any;
  @Input() public readOnly: boolean = false;
  @Output() public removeMethod = new EventEmitter();
  @Output() public updateMethod = new EventEmitter();
  @Output() public emitCauses = new EventEmitter();
  @ViewChild("codeBox") public codeBox: ElementRef;
  //, {static: false}
  public columns: MIshikawaItem[] = [];
  public offset: number = 0;
  public modalTitle: string = "";

  ngOnInit() {
    // this.data = null;
    this.loadCauses();
  }

  ngOnChanges() {
    this.loadCauses();
    // console.log(this.data)
  }

  public loadCauses() {
    this.columns = [];
    if (this.data) {
      if (this.data.length > 0) {
        let fatherIds: number[] = [];
        for (let i = 0; i < this.data.length; i++) {
          if (!this.data[i].fatherId) {
            this.columns.push(this.generate(this.data[i]));
            fatherIds.push(this.data[i].id);
          }
        }
        for (let i = 0; i < this.data.length; i++) {
          for (let j = 0; j < this.columns.length; j++) {
            if (this.data[i].fatherId) {
              if (this.data[i].fatherId === fatherIds[j]) {
                this.columns[j].causes.push(this.data[i]);
              } else {
                if (this.columns[j].causes.length > 0) {
                  if (
                    this.data[i].fatherId ===
                    this.columns[j].causes[this.columns[j].causes.length - 1].id
                  ) {
                    this.columns[j].causes.push(this.data[i]);
                  }
                }
              }
            }
          }
        }
        this.emitData();
      } else {
        this.startMethod();
      }
    } else {
      this.startMethod();
    }
    setTimeout(() => {
      this.offset = this.getElementHeight() / 2;
    }, 10);
  }

  public startMethod() {
    this.columns.push(
      this.generate(
        this.generateCause(this.translate.instant("treatment.causeList.method"))
      )
    );
    this.columns.push(
      this.generate(
        this.generateCause(
          this.translate.instant("treatment.methods.ishikawa.machine")
        )
      )
    );
    this.columns.push(
      this.generate(
        this.generateCause(
          this.translate.instant("treatment.methods.ishikawa.material")
        )
      )
    );
    this.columns.push(
      this.generate(
        this.generateCause(
          this.translate.instant("treatment.methods.ishikawa.measurement")
        )
      )
    );
    this.columns.push(
      this.generate(
        this.generateCause(
          this.translate.instant("treatment.methods.ishikawa.workforce")
        )
      )
    );
    this.columns.push(
      this.generate(
        this.generateCause(
          this.translate.instant("treatment.methods.ishikawa.environment")
        )
      )
    );
  }

  private generateCause(title: string) {
    return new MCause({
      regular: {
        descripcion: title,
        metodo_analisis: {
          id: 1,
          nombre: "treatment.methods.ishikawa.title",
        },
      },
    });
  }

  remove(data) {
    // this.columns = [];
    // this.emitData()
    this.removeMethod.emit(data);
    this.updateMethod.emit(false);
  }

  private generate(title: MCause) {
    return new MIshikawaItem(title, []);
  }

  public add() {
    this.columns.push(
      this.generate(
        new MCause({
          regular: {
            descripcion: this.translate.instant(
              "treatment.methods.ishikawa.standard"
            ),
            metodo_analisis: {
              id: 1,
              nombre: "treatment.methods.ishikawa.title",
            },
          },
        })
      )
    );
    this.emitData();
  }

  public columnAmount(): number {
    return Math.round(this.columns.length / 2);
  }

  public addItem(index: number) {
    if (this.columns[index].input !== "") {
      let push: boolean = true;
      for (let i = 0; i < this.columns[index].causes.length; i++) {
        if (
          this.columns[index].input ===
          this.columns[index].causes[i].description
        ) {
          push = false;
          break;
        }
      }
      if (push) {
        this.columns[index].causes.push(
          this.generateCause(this.columns[index].input)
        );
        this.columns[index].input = "";
      } else {
        this.toast.error(
          this.translate.instant(
            "treatment.methods.ishikawa.alert.repeatedCause.message"
          ),
          this.translate.instant(
            "treatment.methods.ishikawa.alert.repeatedCause.title"
          )
        );
      }
      this.emitData();
    }
  }

  public deleteColumn(modal, index) {
    this.modalTitle = "treatment.methods.because.deleteCriterion";
    this.modalService.open(modal, { centered: true }).result.then(() => {
      this.columns.splice(index, 1);
      this.emitData();
    });
  }

  public deleteItem(modal, index: number, position: number) {
    this.modalTitle = "treatment.methods.because.modalTitle";
    this.modalService.open(modal, { centered: true }).result.then(
      () => {
        this.columns[index].causes.splice(position, 1);
        this.emitData();
      },
      () => {}
    );
  }

  public emitData() {
    let definitiveCauses: MCause[] = [];
    let allCauses: MCauseArray[] = [];
    let method: AnalisisMethod = {
      id: 1,
      nombre: "treatment.methods.ishikawa.title",
    };

    for (let i = 0; i < this.columns.length; i++) {
      allCauses.push(new MCauseArray([]));
      allCauses[i].causes.push(this.columns[i].title);
      for (let j = 0; j < this.columns[i].causes.length; j++) {
        allCauses[i].causes.push(this.columns[i].causes[j]);
        this.columns[i].causes[j].definitiveSelected = this.columns[i].causes[j]
          .definitiveId
          ? this.columns[i].causes[j].definitiveSelected
          : true;
        if (this.columns[i].causes[j].selected) {
          definitiveCauses.push(this.columns[i].causes[j]);
        }
      }
    }
    this.emitCauses.emit({
      data: {
        definitive: definitiveCauses,
        causes: allCauses,
      },
      id: 1,
    });
  }

  public getElementHeight() {
    if (this.codeBox) {
      if (this.codeBox.nativeElement) {
        if (this.codeBox.nativeElement.offsetHeight) {
          return this.codeBox.nativeElement.offsetHeight;
        }
      }
    }
    return 0;
  }

  public onEnter(event, index: number, add: boolean = false) {
    // console.log(event)
    if (add) {
      if (event.keyCode === 13) {
        if (this.columns[index].input !== "") {
          this.addItem(index);
        }
      }
    } else {
      if (event.keyCode === 27 || event.keyCode === 13) {
        this.stopEditing(index);
        this.emitData();
      }
    }
  }

  public stopEditing(index: number) {
    // console.log(index)
    this.columns[index].editing = false;
    if (this.columns[index].title.description === "") {
      this.columns[index].title.description = this.translate.instant(
        "treatment.methods.newCause"
      );
    }
    this.emitData();
  }

  public setFocus(index: number) {
    if (!this.readOnly) {
      this.columns[index].editing = true;
      setTimeout(() => {
        document.getElementById("input-" + index).focus();
      }, 50);
    }
  }
}
